import moment from 'moment';
import Dinero from 'dinero.js';
import { EarningsState } from './state';
import { EarningsOwnerType } from '@services/earnings/types/earnings-owner-type';
import { EarningsResponse } from '@services/earnings/types/earnings-response';
import { EarningsData } from '../../types/ui/earnings/earnings';
import { DistributionEarnings } from '../../types/ui/earnings/distribution-earnings';

export const earningsList = (
  state: EarningsState,
  ownerType: EarningsOwnerType
): EarningsResponse[] => {
  return state.data[ownerType].slice().sort((a, b) => {
    const n1 = moment(a.reportDate, 'YYYY-MM');
    const n2 = moment(b.reportDate, 'YYYY-MM');

    return n2.unix() - n1.unix();
  });
};

export const earningsReport = (
  state: EarningsState,
  ownerType: EarningsOwnerType
): EarningsData[] => {
  const data = earningsList(state, ownerType);

  return data
    .map((report) => {
      const agg: EarningsData['platforms'] = {};
      const categoryAgg: Record<string, DistributionEarnings> = {};

      report.entries.forEach((e) => {
        const platform = e.dsp;

        if (!agg[platform]) {
          agg[platform] = [];
        }
        if (!categoryAgg[e.type]) {
          categoryAgg[e.type] = {
            category: e.type,
            revenue: Dinero({ amount: 0, currency: 'USD', precision: 5 }),
            streams: 0,
            downloads: 0,
          };
        }

        const category = categoryAgg[e.type];

        let found = agg[platform]?.find((a) => a.category === e.type);

        if (!found) {
          found = {
            category: e.type,
            revenue: Dinero({ amount: 0, currency: 'USD', precision: 5 }),
            downloads: 0,
            streams: 0,
          };
          agg[platform]?.push(found);
        }

        found.revenue = found.revenue.add(e.value);
        category.revenue = category.revenue.add(e.value);

        if (e.type === 'Download') {
          found.downloads += e.quantity;
        } else {
          found.streams += e.quantity;
        }
        category.streams += e.quantity;
        category.downloads += e.quantity;
      });

      return {
        date: moment(report.streamsDate, 'YYYY-MM'),
        eligible: moment(report.eligibleDate),
        paid: report.paid ? moment(report.paid) : undefined,
        partialPayment: report.partialPayment,
        total: report.total,
        streams: report.streams,
        downloads: report.downloads,
        distribution: [
          {
            category: 'Recorded Music',
            revenue: report.total,
            streams: report.streams,
            downloads: report.downloads,
          },
        ],
        categories: Object.values(categoryAgg),
        platforms: agg,
      };
    })
    .sort((a, b) => b.date.unix() - a.date.unix());
};
